import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { api, globalErrorHandler } from '../../api/create-api';
import { Row, Col, Button, ButtonGroup, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Alert, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Prompt } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faPlus, faEdit, faList } from '@fortawesome/free-solid-svg-icons';
import { Field } from '@galop/component-library';
import { CancelButton, SelectCollection, SearchableSelect } from '@galop/component-library';

import { GetOptionText, groupBy } from '../../Helpers/Helper';
import { makeCall } from '../../auth-utils';
import Can from '../Shared/Can';
import { DeleteButton } from '@galop/component-library';
import { List } from '../LeaseDetails/List';
import Lock from '../Shared/Lock';

export const ViewAsset = (props) => {
    const ls = require('local-storage');
    const { config, IsDirty, resource, userId, Close, Save, NewResource, ReloadResources, questions, setQuestions, polices, setPolicies } = props;
    const { addToast, removeToast } = useToasts();

    /* Generic Variables */
    const [resourceRecord, setResourceRecord] = useState(resource || {});
    const [editResource, setEditResource] = useState(NewResource);
    const [resourceIsDirty, setResourceIsDirty] = useState(false);

    /* Asset Specific Variables */
    const [redirect, setRedirect] = useState('');
    const [showAddress, setShowAddress] = useState(true);
    const [editing, setEditing] = useState(false);

    useEffect(() => {
        IsDirty(resourceIsDirty || editing);
    }, [resourceIsDirty, editing]);

    useEffect(() => {
        if (resource) {
            setResourceRecord(resource);
            if (('loaded' in resource) && !resource.loaded) {
                addToast(`Loading ${resource.name} data...`, { appearance: 'info', id: 'loading-data' });
            }
            else {
                removeToast('loading-data');
            }
        }
    }, [resource]);

    const getUpdatedResource = () => {
        makeCall(async (authHeader) => {
            const result = await api(`api/${config.controllerName}/gsr-companies/changes/${resource.id}`, {
                headers: authHeader
            })
                .catch(error => globalErrorHandler(error, addToast));

            if (result && result.data) {
                setResourceRecord(result.data);
                setEditResource(true);
                setResourceIsDirty(true);
            }
        });
    };

    const deleteResource = async () => {
        makeCall(async (authHeader) => {
            addToast(`Deleting ${config.capitalResourceName}`, { appearance: 'info', id: 'deleting-resource' });
            await api.delete(`api/${config.controllerName}/${resourceRecord.id}`, {
                headers: authHeader
            }).catch((error) => globalErrorHandler(error, addToast));
            removeToast('deleting-resource', () => {
                setResourceIsDirty(false);
                if (Save) {
                    Save({ ...resourceRecord, deleted: !resource.deleted });
                }

                Close();
            });
        });
    };

    const goToPage = (resource, to) => {
        if (resource) {
            ls(config.localStorage, resource);
        }
        setRedirect(to);
    };

    return (
        <div className="mb-2 d-flex flex-column h-100">
            {redirect && <Redirect to={redirect} />}
            <Prompt when={resourceIsDirty} message='You have unsaved changes, are you sure you want to leave?' />
            <Row>
                <Col className="d-flex">
                    <div className="d-inline-block d-md-none">
                        <Button color="link" className="py-0" onClick={Close}><FontAwesomeIcon icon={faChevronLeft} /></Button>
                    </div>
                    <div className="flex-fill d-flex">
                        <span className="h3 text-dark pb-0 mb-0">{resource.name}</span>
                        <div className="flex-fill">
                            <Lock
                                locked={() =>
                                    <Button color="link" size="sm" className={`text-secondary ${editResource || editing ? 'd-none' : 'd-inline'}`} onClick={() => setEditResource(!editResource)}><FontAwesomeIcon icon={faList} /> View</Button>
}
                                unlocked={() =>
                                    <Button color="link" size="sm" className={`text-secondary ${editResource || editing ? 'd-none' : 'd-inline'}`} onClick={() => setEditResource(!editResource)}><FontAwesomeIcon icon={faEdit} /> Edit</Button>
                                }
                            />
                        </div>
                    </div>
                </Col>
            </Row>
            <div className="flex-fill scrollable-list border-top border-bottom" style={{ overflow: 'scroll' }}>
                <div className="pl-1 pr-3">
                    <List className="mt-2" {...{ userId, editAsset: editResource, setEditAsset: setEditResource, selectedAsset: resource, questions, setQuestions, polices, setPolicies, editing, setEditing }} userId={userId} selectedAsset={resource} showDeleted />
                </div>
            </div>
            {!editResource &&
                <Row className="pt-1">
                    {resourceRecord.deleted ?
                        <Can role={config.writeRole}
                            yes={() => <Col>
                                <Button color="secondary" outline onClick={deleteResource}>Recover</Button>
                            </Col>}
                        />
                        : <Can role={config.writeRole}
                            yes={() => <Col>
                                <DeleteButton color="danger" outline Close={deleteResource} ShowDropdown={true}>Delete</DeleteButton>
                            </Col>}
                        />}
                    <Col className="text-right">
                        <Button color="light" className="border mr-1" onClick={Close}>Close</Button>
                    </Col>
                </Row>
            }
        </div >
    );
};


// WEBPACK FOOTER //
// ./src/components/Assets/ViewAsset.js